import Classic from './Classic/Classic';
import Schematic from './Schematic/Schematic';

const templates = {
  Classic,
  Schematic,
};

export default templates;
